<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :title="isSpouseCreationMode ? 'Création fiche conjoint(e)' : 'Création d\'un Contact'">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :has-padd-left-on-act="true"
      :has-padd-right-on-act="true"
      :has-sticky-col-left="true"
      :set-main-col-class="'is-12 is-11-widescreen is-10-fullhd'">
      <div class="columns">
        <div class="column is-3 is-2-fullhd">
          <aside class="menu menu--admin">
            <ul class="menu-list has-background-white is-border">
              <li :class="{'is-active' : panel === 'CONTACT_CREATE'}">
                <a @click="panel = 'CONTACT_CREATE'">Fiche contact</a>
              </li>
              <li :class="{'is-active' : panel === 'IMPORT_CONTACT'}">
                <a @click="panel = 'IMPORT_CONTACT'">Import automatique</a>
              </li>
            </ul>
          </aside>
        </div>
        <div class="column">
          <div v-show="panel === 'CONTACT_CREATE'">
            <contact-form
              @submit="createContact"
              :source-loading="loading"
              :new-contact="true"></contact-form>
          </div>
          <div v-show="panel === 'IMPORT_CONTACT'">
            <contact-import></contact-import>
          </div>
        </div>
      </div>
    </page-content>
  </div>
</template>

<script>
import ContactMixin from './ContactMixin'

export default {
  name: 'ContactCreate',
  components: {
    ContactForm: () => import('@/components/contacts/ContactForm'),
    ContactImport: () => import('@/components/contacts/ContactImport')
  },
  mixins: [ContactMixin],
  data () {
    return {
      panel: 'CONTACT_CREATE'
    }
  },
  computed: {
    isSpouseCreationMode () {
      return this.$route.query.spouseMode === true && this.$route.query.parentContactId
    }
  }
}
</script>
